import { useState, useCallback } from 'react';
// @mui
import { Drawer, Fab, Tooltip } from '@mui/material';
// components
import Iconify from '../../../components/iconify';
// locales
import { useLocales } from '../../../locales';
// sections
import { CoachChatWindow } from '../../../sections/coach';

// ----------------------------------------------------------------------

// Tribz Coach is temporarily hidden while being reworked. Set to true to bring it back.
const COACH_ENABLED: boolean = false;

// ----------------------------------------------------------------------

export default function CoachDrawerButton() {
  const { translate } = useLocales();
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  if (!COACH_ENABLED) {
    return null;
  }

  return (
    <>
      {!open && (
        <Tooltip title={translate('tribz_coach')}>
          <Fab
            color="primary"
            aria-label={translate('tribz_coach')}
            onClick={handleOpen}
            sx={{
              position: 'fixed',
              bottom: 24,
              right: 24,
              zIndex: 1300,
            }}
          >
            <Iconify icon="ic:round-assistant" width={24} height={24} />
          </Fab>
        </Tooltip>
      )}

      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: 420, md: 480 },
          },
        }}
      >
        <CoachChatWindow onClose={handleClose} />
      </Drawer>
    </>
  );
}
